import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { getAnalytics, type Analytics } from "firebase/analytics";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getAuth, type Auth } from "firebase/auth";

const firebaseConfig = {
  apiKey: `${import.meta.env.VITE_FIREBASE_KEY}`,
  authDomain: `${import.meta.env.VITE_AUTH_DOMAIN}`,
  projectId: `${import.meta.env.VITE_GCP_PROJECT_ID}`,
  storageBucket: `${import.meta.env.VITE_FIREBASE_STOREAGE_BUCKET}`,
  messagingSenderId: `${import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID}`,
  appId: `${import.meta.env.VITE_FIREBASE_APP_ID}`,
  measurementId: `${import.meta.env.VITE_FIREBASE_MEASUREMENT_ID}`
};

const databaseId: string = import.meta.env.VITE_FIREBASE_DB_ID;
if (!databaseId) {
  throw new Error('VITE_FIREBASE_DB_ID is not set. Check your environment variables.');
}

// All three calls are synchronous -- safe to run at module scope so every
// consumer that imports this module gets a ready instance immediately.
const firebaseApp: FirebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

const db: Firestore = getFirestore(firebaseApp, databaseId);
const auth: Auth = getAuth(firebaseApp);

// Analytics requires the DOM, so initialise lazily on first access.
let _analytics: Analytics | null = null;

export { db, auth, firebaseConfig };

export const getFirestoreDB = (): Firestore => db;

export const getFirebaseAuth = (): Auth => auth;

export const getFirebaseAnalytics = (): Analytics => {
  if (!_analytics) {
    _analytics = getAnalytics(firebaseApp);
  }
  return _analytics;
};